import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { FeatureDiscoveryActions } from '@core/feature-discovery-data';

@Injectable({ providedIn: 'root' })
export class CandidatePersonalDetailsFormActionsService {
  private readonly store = inject(Store);

  public setShowSalutationFieldsUsed(show: boolean): void {
    this.store.dispatch(
      FeatureDiscoveryActions.update({ payload: { showSalutationFieldsUsed: show } }),
    );
  }
}
